<template>
    <Row class="check" type="none">

        <RowColumn>
            <Row type="none">
                <div class="ml-1">
                    <TextTag class="d-flex justify-content-center" style="font-size: 28px" :is-block=true
                             :is-bold="true">
                        "{{ getUserCompany.name }}"
                    </TextTag>
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('printView.receipt') }} {{ getSale.id }}
                    </TextTag>
                    <TextTag v-if="getUser.person.telephone" :is-block=true :is-bold="true">
                        {{ $t('company.title') }} {{ $t('company.telephone') }}: {{ getUser.person.telephone }}
                    </TextTag>
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('date') }}: {{ dateTimeFormat(getSale.createdAt) }}
                    </TextTag>
                    <TextTag v-if="getUser.person" :is-block=true :is-bold="true">
                        {{ $t('sale.seller') }}: {{ getUser.person.givenName }} {{ getUser.person.familyName }}
                    </TextTag>
                    <hr class="m-0 p-0" style="border: 1px solid black">

                </div>
            </Row>
        </RowColumn>

        <GoBackButton class="mt-3 mr-2 go-back-btn"/>

        <div>
            <table
                v-if="getSale.id !== null"
                class="table"
                style="border-bottom: 2px dotted black !important;"
            >
                <tbody>
                <tr v-for="(item, index) in getSale.saleProducts.concat(getSale.saleServices)"
                    v-bind:key="index">
                    <td style="border-bottom: 2px dotted black !important">
                        <div style="font-weight: bold" v-if="item['@type'] === 'SaleProduct'">
                            {{ getProductName(item) }}
                        </div>
                        <div v-else>
                            <span style="font-weight: bold">{{ item.service.name + ' ' }}</span>
                            <span style="font-size: 12px">{{ '(' + $t('service.title') + ')' }}</span>
                        </div>
                        <div class="d-flex justify-content-between" style="font-size: 11px">
                            <div>{{ getProductAmountAndUnitOfMeasure(item) }} * {{ showPrice(item) }}</div>
                            <div>{{ showTotalRowPrice(item) }}</div>
                        </div>
                        <span v-if="item['@type'] === 'SaleProduct'">
                            <div v-if="item.product.tax !== null"
                                 class="d-flex justify-content-between" style="font-size: 14px">
                                <div>{{ getTax(item) }}</div>
                                <div>{{ getTaxAmount(item) }}</div>
                            </div>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td v-if="getSale.saleServices.length > 0"
                        class="d-flex justify-content-between">
                        <div>{{ $t('service.servicePrice') }}</div>
                        <div>
                            {{
                                showCurrencyById(
                                    getSale.currency.id, getServicesTotalPrice(getSale.saleServices))
                            }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td
                        class="d-flex justify-content-between"
                    >
                        <div>
                            <h5>{{ $t('sale.totalSum') }}</h5>
                        </div>
                        <div>
                            <h5>
                                {{
                                    getPrice()
                                }}
                            </h5>
                        </div>
                    </td>
                </tr>

                <tr v-if="getSale.bonusSumAmount > 0">
                    <td
                        class="d-flex justify-content-around"
                    >
                        <div>
                            <h5>{{ $t('sale.discount.title') }}</h5>
                        </div>
                        <div>
                            <h5>{{ showCurrencyById(getSale.currency.id, getSale.bonusSumAmount) }}</h5>
                        </div>
                    </td>
                </tr>
                <tr v-if="getSale.discountPercent > 0">
                    <td
                        class="d-flex justify-content-between">
                        <div>
                            <h5>{{ $t('sale.discount.title') }}</h5>
                        </div>
                        <div>
                            <h5>{{
                                    getSale.discountPercent + '% = ' + showCurrencyById(getSale.currency.id, parseFloat(getSale.bonusPercentAmount))
                                }}</h5>
                        </div>
                    </td>
                </tr>

                <tr>

                    <td v-if="getSale.saleTaxes.length > 0"
                        class="d-flex justify-content-between"
                        style="font-weight: bold">
                        <div>
                            <h5>{{ getSale.isTaxInPrice ? $t('sale.tax.inPriceOnCheck') : '' }}{{
                                    $t('sale.tax.title')
                                }}</h5>
                        </div>
                        <div>

                            <h5>{{ showCurrencyById(getSale.currency.id, getSale.saleTaxes[0].price) }}</h5>
                        </div>
                    </td>
                    <td v-else-if="taxAmount > 0"
                        class="d-flex justify-content-between"
                        style="font-weight: bold">
                        <div>
                            <h5>{{ getSale.isTaxInPrice ? $t('sale.tax.inPriceOnCheck') : '' }}{{
                                    $t('sale.tax.title')
                                }}</h5>
                        </div>
                        <div>
                            <h5>{{ showCurrencyById(getSale.currency.id, taxAmount) }}</h5>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td
                        class="d-flex justify-content-between"
                    >
                        <div>
                            <h5>{{ $t('sale.finalSum') }}</h5>
                        </div>
                        <div>
                            <h5>
                                {{
                                    showCurrencyById(getSale.currency.id, parseFloat(getSale.totalPurchaseAmount))
                                }}
                            </h5>
                        </div>
                    </td>
                </tr>

                <tr v-if="parseFloat(getSale.cashback)">
                    <td
                        class="d-flex justify-content-between">
                        <div>
                            <h5>{{ $t('customer.cashback.payFromCashback') }}</h5>
                        </div>
                        <div>
                            <h5>
                                {{
                                    showCurrencyById(getSale.currency.id, getSale.cashback)
                                }}
                            </h5>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td
                        class="d-flex justify-content-between">
                        <div>
                            <h5>{{ $t('payed') }}</h5>
                        </div>
                        <div>
                            <h5>
                                {{
                                    showCurrencyById(getSale.currency.id, (parseFloat(getSale.payedAmount) + parseFloat(getSale.oddMoney)) - parseFloat(getSale.cashback))
                                }}
                            </h5>
                        </div>
                    </td>
                </tr>

                <tr v-if="Math.round(getSale.totalPrice - getSale.payedAmount) > 0 && !getSale.transaction">
                    <td
                        class="d-flex justify-content-around">
                        <div>
                            <h5>{{ $t('debt') }}</h5>
                        </div>
                        <div>
                            <h5>
                                {{
                                    showCurrencyById(getSale.currency.id, getSale.totalPurchaseAmount - getSale.payedAmount - getSale.bonusSumAmount)
                                }}
                            </h5>
                        </div>
                    </td>
                </tr>
                <tr v-if="parseFloat(getSale.oddMoney) > 0.0">
                    <td class="d-flex justify-content-around">
                        <div>
                            <h5>{{ $t('sale.oddMoney') }}</h5>
                        </div>
                        <div>
                            <h5>{{ showCurrencyById(getSale.currency.id, getSale.oddMoney) }}</h5>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <pre class="d-none">{{ sales }}</pre>

        </div>
        <RowColumn>
            <Row type="none">
                <div class="mr-1 font-size">
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('customer.title') }}: {{ getCustomerName(getSale) }}
                    </TextTag>
                    <hr class="m-0 p-0">
                    <TextTag v-if="getCustomerPhoneNumber(getSale)" :is-block=true :is-bold="true">
                        {{ getCustomerPhoneNumber(getSale) }}
                    </TextTag>
                    <hr class="m-0 p-0" style="border: 1px solid black">
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('hasPayed') }}: {{ getSale.transaction ? $t('yes') : $t('no') }}
                    </TextTag>
                    <hr class="m-0 p-0" style="border: 0.5px solid black">
                    <TextTag :is-block=true v-if="getSale.company.tin">
                        {{ $t('companyRequisites.tin') }}:
                        <span style="font-weight: bold">{{ getSale.company.tin }}</span>
                    </TextTag>
                    <TextTag :is-block=true v-if="getSale.company.gceo">
                        {{ $t('companyRequisites.gceo') }}:
                        <span style="font-weight: bold">{{ getSale.company.gceo }}</span>
                    </TextTag>
                    <hr v-if="getSale.company.tin || getSale.company.gceo" class="m-0 p-0"
                        style="border: 0.5px solid black">
                    <TextTag :is-block=true v-if="getSale.company.legalAddress">
                        {{ $t('companyRequisites.legalAddress') }}:
                        <span style="font-weight: bold">{{ getSale.company.legalAddress }}</span>
                    </TextTag>
                    <TextTag :is-block=true v-if="getSale.company.physicalAddress">
                        {{ $t('companyRequisites.physicalAddress') }}:
                        <span style="font-weight: bold">{{ getSale.company.physicalAddress }}</span>
                    </TextTag>
                    <hr v-if="getSale.company.legalAddress || getSale.company.physicalAddress" class="m-0 p-0"
                        style="border: 0.5px solid black">
                    <TextTag :is-block=true v-if="getSale.company.chiefDirector">
                        {{ $t('companyRequisites.chiefDirector') }}:
                        <span style="font-weight: bold">{{ getSale.company.chiefDirector }}</span>
                    </TextTag>
                    <hr v-if="getSale.company.chiefDirector"
                        class="m-0 p-0" style="border: 0.5px solid black">
                    <TextTag :is-block=true>
                        <div class="font-weight-bold" style="font-size: 10px">
                            {{ getInfo }}
                        </div>
                    </TextTag>
                    <hr v-if="getInfo" class="m-0 p-0" style="border: 0.5px solid black">
                    <TextTag class="d-flex justify-content-center"
                             style="font-size: 20px; font-weight: normal !important;" :is-block=true
                             :is-bold="true">
                        {{ $t('sale.thankPurchase') }}!!!
                    </TextTag>
                </div>
            </Row>
        </RowColumn>

        <GoBackButton class="my-3 mr-2 go-back-btn" v-if="getSale.saleProducts.length >= 37"/>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import Row from "@/components/html/Row";
import TextTag from "@/components/html/TextTag";
import GoBackButton from "@/components/GoBackButton";
import RowColumn from "@/components/RowColumn";
import PrintStyleMixin from "@/mixin/PrintStyleMixin";
import CurrencyRateMixin from "@/mixin/currencyRateMixin";

export default {
    name: "ShowPrintCheckVersion",
    mixins: [currencyFormatMixin, dateFormattingMixin, PrintStyleMixin, CurrencyRateMixin],
    components: {
        GoBackButton,
        TextTag,
        Row,
        RowColumn
    },
    computed: {
        ...mapGetters(['getSale', 'isAuthenticated', 'getUser', 'getCustomer', 'getUserCompany', 'getUserPerson', 'getInfo']),
        sales() {
            return this.getSale.saleProducts.map((product) => {
                product.amount = parseFloat(product.amount)
            })
        }
    },
    data() {
        return {
            taxAmount: 0
        }
    },
    methods: {
        ...mapActions(['fetchSale', 'fetchUser', 'fetchRefreshToken', 'fetchCustomer']),
        checkTaxInPrice() {
            this.getSale.saleProducts.map(item => {
                if (item.product.tax !== null) {
                    if (this.getSale.isTaxInPrice) {
                        this.taxAmount += this.getTaxInPriceAmount(item.price, item.product.tax.percent)
                    } else {
                        this.taxAmount += item.price * item.product.tax.percent / 100
                    }
                }
            })
        },
        getPrice() {
            let tax = this.getSale.saleTaxes.length > 0 ? this.getSale.saleTaxes[0].price : 0

            if (tax > 0) {
                return this.showCurrencyById(
                    this.getSale.currency.id,
                    this.getSale.totalPurchaseAmount > 0 ?
                        parseFloat(this.getSale.totalPurchaseAmount) + parseFloat(this.getSale.bonusSumAmount) + parseFloat(this.getSale.bonusPercentAmount) - tax :
                        this.getSale.totalPrice - tax)
            }

            return this.showCurrencyById(
                this.getSale.currency.id,
                this.getSale.totalPurchaseAmount > 0 ?
                    parseFloat(this.getSale.totalPurchaseAmount) + parseFloat(this.getSale.bonusSumAmount) + parseFloat(this.getSale.bonusPercentAmount) :
                    parseFloat(this.getSale.totalPrice) + parseFloat(this.getSale.bonusSumAmount) + parseFloat(this.getSale.bonusPercentAmount))


        },
        calculateReversePercentAmount(amount, percent) {
            if (percent === null) {
                percent = 0
            }

            return amount * 100 / (100 - percent)
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        },
        getServicesTotalPrice(saleServices) {
            let totalPrice = 0.0
            for (let saleService of saleServices) {
                totalPrice += parseFloat(saleService.price)
            }

            return totalPrice
        },
        getTaxAmount(saleProductOrService) {
            let tax = saleProductOrService.product.tax ?? this.getUserCompany.tax

            return this.showCurrencyById(
                this.getSale.currency.id,
                this.getSale.isTaxInPrice ?
                    this.getTaxInPriceAmount(saleProductOrService.price, tax.percent) :
                    saleProductOrService.price * parseFloat(tax.percent) / 100
            )
        },
        getTaxInPriceAmount(amount, percent) {
            return amount * parseFloat(percent) / 100
        },
        getTax(saleProductOrService) {
            let tax = saleProductOrService.product.tax ?? this.getUserCompany.tax
            let taxInPrice = this.getSale.isTaxInPrice ? this.$t('sale.tax.inPriceOnCheck') : ''

            return taxInPrice + tax.name + ' ' + parseFloat(tax.percent) + ' %'
        },
        getProductName(saleProductOrService) {
            if (saleProductOrService['@type'] === "SaleProduct") {
                return saleProductOrService.product.name
            }

            return saleProductOrService.service.name + ' ' + '(' + this.$t('service.title') + ')'
        },
        getProductAmountAndUnitOfMeasure(saleProductOrService) {
            if (saleProductOrService['@type'] === "SaleProduct") {
                if (saleProductOrService.amountWithMeasure) {
                    return saleProductOrService.amountWithMeasure
                }

                this.checkForAdditionalUnitOfMeasure(saleProductOrService)
            }

            return parseFloat(saleProductOrService.amount)

        },
        checkForAdditionalUnitOfMeasure(saleProduct) {
            let amount = saleProduct.amount
            let response = ''

            if (saleProduct.product.additionalUnitOfMeasures.length > 0) {
                let measures = saleProduct.product.additionalUnitOfMeasures.sort((a, b) => b.howMany - a.howMany)

                measures.map((measure, index) => {
                    if (index > 0) {
                        response += ', '
                    }

                    response += Math.floor(amount / measure.howMany) + ' ' + measure.unitOfMeasure

                    amount %= measure.howMany
                })

                if (amount > 0) {
                    response += ', ' + amount + ' ' + this.showUnitOfMeasurement(saleProduct)
                }

                return saleProduct.amountWithMeasure = parseFloat(response)
            }

            return saleProduct.amountWithMeasure =
                parseFloat(saleProduct.amount) + ' ' + this.showUnitOfMeasurement(saleProduct)
        },
        showUnitOfMeasurement(saleProduct) {
            return this.showUnitOfMeasure(saleProduct.product.unitOfMeasure)
        },
        showTotalRowPrice(saleProductOrService) {
            if (saleProductOrService['@type'] === "SaleProduct") {
                let tax = saleProductOrService.product.tax ?? this.getUserCompany.tax

                if (tax === null) {
                    tax = {
                        percent: 0
                    }
                }

                return this.showCurrencyById(
                    this.getSale.currency.id,
                    this.getSale.isTaxInPrice ?
                        this.getPriceWithoutTax(saleProductOrService.price, tax.percent) :
                        saleProductOrService.price
                )
            }

            return this.showCurrencyById(this.getSale.currency.id, saleProductOrService.price)

        },
        getPriceWithoutTax(price, percent) {
            return price + ((parseFloat(price) * parseFloat(percent)) / 100)
        },
        showPrice(saleProductOrService) {
            if (saleProductOrService['@type'] === "SaleProduct") {
                let tax = saleProductOrService.product.tax ?? this.getUserCompany.tax

                if (tax === null) {
                    tax = {
                        percent: 0
                    }
                }

                let isBonus = false
                let isPercent = false
                let percent = 0

                this.getSale.discount.find(d => {
                    if (
                        d.discount.discountType === 'product' &&
                        d.discount.discountProducts.find(dp =>
                            dp.isBonus &&
                            dp.product.id === saleProductOrService.product.id &&
                            parseFloat(saleProductOrService.price) === 0.0
                        ) !== undefined
                    ) {
                        return isBonus = true
                    } else if (d.discount.discountType === 'percent') {
                        if (
                            !d.discount.isForAllProducts &&
                            d.discount.discountProducts.find(dp =>
                                !dp.isBonus &&
                                dp.product.id === saleProductOrService.product.id
                            )
                            !== undefined
                        ) {
                            percent = d.discount.discountPercent
                            return isPercent = true
                        }
                    }
                })

                if (isBonus) {
                    return this.$t('sale.discount.discountProduct')
                }

                if (isPercent) {
                    return this.showCurrencyById(
                            this.getSale.currency.id,
                            this.calculateReversePercentAmount(
                                this.getPriceWithoutTax(saleProductOrService.price, tax.percent),
                                percent) / saleProductOrService.amount
                        ) + ' - ' + percent + '% = ' +
                        this.showCurrencyById(
                            this.getSale.currency.id,
                            this.getPriceWithoutTax(saleProductOrService.price, tax.percent) / saleProductOrService.amount
                        )
                }

                return this.showCurrencyById(
                    this.getSale.currency.id,
                    saleProductOrService.price / saleProductOrService.amount
                )
            }

            return this.showCurrencyById(this.getSale.currency.id, saleProductOrService.price / saleProductOrService.amount)

        },
        getCustomerName(item) {
            return item.customer.isCompany ?
                item.customer.customerCompany.name : item.customer.person ?
                    item.customer.person.givenName + ' ' + item.customer.person.familyName : ''
        },
        getCustomerPhoneNumber(item) {
            if (!item.customer.isCompany) {
                return item.customer.person.telephone
            }

            return false
        },
        printWindow() {
            window.print()
            setTimeout(() => {
                this.$i18nHelper.toUrl('sales/sale')
            }, 1000)
        },
    },
    mounted() {
        this.fetchCustomer()

        if (this.getSale.id === null) {
            this.$root.showOverlay = true
            this.fetchSale(this.$route.params.id)
                .finally(() => {
                    this.$root.showOverlay = false
                    this.checkTaxInPrice()
                    setTimeout(() => {
                        this.printWindow()
                    }, 500)
                })
        } else {
            this.checkTaxInPrice()
            setTimeout(() => {
                this.printWindow()
            }, 500)
        }
    },
    beforeDestroy() {
        this.removePrintStyle();
    },
}
</script>

<style scoped>
@media print {
    .check {
        width: 320px;
        margin: 0;
        padding: 0;
    }

    .go-back-btn {
        display: none;
    }

    td {
        padding: 8px;
    }

    h5 {
        font-size: 16px;
    }

    @page {
        size: 62mm 100mm;
        margin: 20px 0;
        padding: 0;
    }
}

.border {
    border-right: 1px solid black !important;
    border-bottom: 1px solid black !important;
    border-left: 1px solid black !important;
}

.check {
    font-family: 'Roboto', SansSerif, sans-serif;
    color: black !important;
}

.font-size {
    font-size: 13px;
}

.font-weight-bold {
    font-size: 10px;
}

h5 {
    font-weight: bold;
}
</style>
